import { auth, db } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";

/**
 * Create an admin user in Firebase
 * This function creates a user account and adds admin role to Firestore
 * If user already exists in Auth, it will create/update the Firestore document
 */
export const createAdminUser = async (email, password, adminData) => {
  try {
    let user;

    try {
      // Try to create user with email and password
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      user = userCredential.user;
    } catch (authError) {
      // If user already exists, sign in and use that user
      if (authError.code === "auth/email-already-in-use") {
        try {
          const userCredential = await signInWithEmailAndPassword(
            auth,
            email,
            password
          );
          user = userCredential.user;

          // Check if Firestore document already exists
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            return {
              success: false,
              error:
                "User already exists with this email. Please use a different email or log in.",
            };
          }
        } catch (signInError) {
          return {
            success: false,
            error:
              signInError.code === "auth/wrong-password"
                ? "User exists but password is incorrect. Please use the correct password or use a different email."
                : signInError.message,
          };
        }
      } else {
        throw authError;
      }
    }

    // Add user data to Firestore with admin role
    await setDoc(doc(db, "users", user.uid), {
      uid: user.uid,
      email: email,
      role: "admin",
      firstName: adminData.firstName || "Admin",
      lastName: adminData.lastName || "User",
      phoneNumber: adminData.phoneNumber || null,
      createdAt: new Date().toISOString(),
    });

    console.log("Admin user created successfully!");
    console.log("User ID:", user.uid);
    console.log("Email:", email);

    return {
      success: true,
      user: user,
      message: "Admin user created successfully!",
    };
  } catch (error) {
    console.error("Error creating admin user:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Example usage (you can call this from console or create a setup page):
 *
 * import { createAdminUser } from './utils/createAdmin';
 *
 * createAdminUser(
 *   "admin@autoshkollaburimi.com",
 *   "YourSecurePassword123!",
 *   {
 *     firstName: "Admin",
 *     lastName: "Burimi",
 *     phoneNumber: "+383 XX XXX XXX"
 *   }
 * );
 */
